import React, { useState } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import FadeIn from 'react-fade-in'
import DateChooser from './DateChooser'
import { connect } from 'react-redux'
import { setStart } from '../reducers/StartDateReducer'
import { setEnd } from '../reducers/EndDateReducer'
import { setNotification } from '../reducers/NotificationReducer'
import { setData } from '../reducers/dataReducer'
import DefaultView from './DefaultView'
import GraphDisplay from './GraphDisplay'
import dataService from '../services/dataService'
import moment from 'moment'
// Ei enää käytössä
const FirstIndoorSensor = (props) => {

  //const [ csvDatas, setCsvDatas ] = useState(null)
  const [ sensor, setSensor ] = useState('')
  const [ csvDatas, setCsvDatas ] = useState('')
  const [ unifiedData, setUnifiedData ] = useState('')

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (props.start !== null && props.end !== null) {
      const formatStart = props.start.getTime()
      const formatEnd = props.end.getTime()
      console.log('Body schema: ', formatStart, formatEnd)

      try {
        props.setNotification('Searching from database...')
        let url = sensor.service
        const data = await dataService.getIndoor1({
          url, formatStart, formatEnd
        })
        const outData = await dataService.getOutdoor({
          formatStart, formatEnd
        })

        const iterData = data.docs
        const sortedIteratedData = iterData.sort((a, b) => a.Timestamp - b.Timestamp)

        const iterOutdoorData = outData.docs
        const sortOutdoorData = iterOutdoorData.sort((a,b) => a.Timestamp - b.Timestamp)

        const formatOutdoorTimestamp = sortOutdoorData.map(m => {
          const ts = new Date(m.measurements.Timestamp)
          console.log(ts)
          return {
            Timestamp: moment(ts).format('HH D.M.YYYY'),
            Humidity: m.measurements.Humidity,
            Temperature: m.measurements.Temperature
          }
        })
        const formatCsv = sortedIteratedData.map(m => {
          const formatTs = new Date(m.Timestamp)
          return {
            Date: new Date(formatTs).toLocaleDateString('fi-FI'),
            Time: new Date(formatTs).toLocaleTimeString('fi-FI'),
            Temperature: m.Measurements.temperature_1.toString().replace('.',','),
            Humidity: m.Measurements.humidity_1.toString().replace('.',','),
            AirPressure: m.Measurements.pressure_1.toString().replace('.',','),
            VOC: m.Measurements.voc_1.toString().replace('.',','),
            Luminance: m.Measurements.illumination_1.toString().replace('.',',')
          }
        })

        const formatIndoorTimestamp = sortedIteratedData.map(m => {
          const formatTs = new Date(m.Timestamp)
          return {
            Timestamp: moment(formatTs).format('HH D.M.YYYY'),
            Temperature: m.Measurements.temperature_1.toString().replace('.',','),
            Humidity: m.Measurements.humidity_1.toString().replace('.',','),
            AirPressure: m.Measurements.pressure_1.toString().replace('.',','),
            VOC: m.Measurements.voc_1.toString().replace('.',','),
            Luminance: m.Measurements.illumination_1.toString().replace('.',',')
          }
        })
        const unifiedData = {
          in: formatIndoorTimestamp,
          out: formatOutdoorTimestamp
        }
        setUnifiedData(unifiedData)
        setCsvDatas(formatCsv)
        props.setData(sortedIteratedData)
        props.setNotification('')
      } catch (exception) {
        console.log(exception)
        console.log('Error happened with async req')
      }
    }
  }

  console.log(csvDatas)

  return (
    <div>
      <FadeIn transitionDuration="1000">
        <DateChooser handleSubmit={handleSubmit} sensor={sensor} setSensor={setSensor} />

        {
          props.data.length === 0 ?
            <DefaultView /> :
            <GraphDisplay datas={props.data} unifiedData={unifiedData} />
        }
      </FadeIn>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    notification: state.notification,
    start: state.start,
    end: state.end,
    data: state.data
  }
}

const mapDispatchToProps = {
  setNotification,
  setStart,
  setEnd,
  setData
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FirstIndoorSensor)